import {
  Input,
  Row,
  Col,
  Card,
  Typography,
  Space,
  Button,
  Form,
  Table,
  Popconfirm,
  notification,
  Select,
  Radio,
} from "antd";
import { DeleteFilled, ExportOutlined, SyncOutlined, AccountBookOutlined, PlusCircleOutlined, EditOutlined, SaveOutlined, CloseOutlined, SearchOutlined } from "@ant-design/icons";
import "../Pages/CSS/DonnesBases.css";
import "../Pages/CSS/Traitement.css";
import { useEffect, useState } from "react";
import * as XLSX from "xlsx";

import { PlanComptService } from "../Services/PlanComptService";
const { Title } = Typography;
const { Option } = Select;
const PlanCompta = () => {
  const initialTableData = []; // Stocke les données initiales du tableau
  const initialNewPrestation = {
    intitule: "",
    compte: "",
    type_compte: "Autres",
    solde: "0",
  };
  const [form] = Form.useForm();
  const [tableData, setTableData] = useState(initialTableData);
  const [filteredData, setFilteredData] = useState(initialTableData); // Utilise initialTableData pour initialiser filteredData
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showCreateForm, setShowCreateForm] = useState(true);
  const [newPrestation, setNewPrestation] = useState(initialNewPrestation);
  const [typeCompte, setTypeCompte] = useState("");

  const plancomptaService = new PlanComptService();


  /*  useEffect(() => {
     setLoading(true);
     plancomptaService
       .getAllPlanCompta() // Ajoutez les parenthèses pour appeler la fonction
       .then((data) => {
         setTableData(data);
         setLoading(false);
       })
       .catch((error) => {
         setLoading(false);
       });
     // eslint-disable-next-line
   }, []); */
  const fetchAllPlanCompta = async () => {
    setLoading(true);
    try {
      const data = await plancomptaService.getAllPlanCompta();
      setTableData(data);
      setFilteredData(data); // Set initial filtered data
    } catch (error) {
      console.error("Erreur lors de la récupération du plan comptable :", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllPlanCompta(); // Initial fetch on component mount
  }, []);

  const handleUpdate = async () => {
    try {
      // Assure-toi que selectedRowData contient les données nécessaires à la mise à jour
      if (!selectedRowData) {
        notification.error({
          message: "Erreur",
          description: "Aucun compte sélectionné pour la mise à jour.",
        });
        return;
      }

      // Affiche un indicateur de chargement
      setLoading(true);

      // Appelle l'API pour mettre à jour le compte
      await plancomptaService.updatePlanCompta(selectedRowData);

      // Après une mise à jour réussie, rafraîchis la liste complète des comptes
      const updatedData = await plancomptaService.getAllPlanCompta();
      setTableData(updatedData); // Met à jour l'état avec les données fraîchement récupérées

      // Notification de succès
      notification.success({
        message: "Succès",
        description: "La mise à jour a été effectuée avec succès.",
      });

      // Réinitialise la sélection et ferme le formulaire de modification
      setSelectedRowData(null);
      setShowCreateForm(true); // Selon ta logique d'application, tu peux vouloir ouvrir ou fermer le formulaire après la mise à jour
    } catch (error) {
      // Gère les erreurs avec une notification appropriée
      notification.error({
        message: "Erreur",
        description: "Une erreur s'est produite lors de la mise à jour.",
      });
      console.error("Erreur lors de la mise à jour du plan compta:", error);
    } finally {
      // Arrête l'indicateur de chargement
      setLoading(false);
    }
  };

  useEffect(() => {
    setFilteredData(tableData); // Initialisation des données filtrées avec les données complètes au chargement
  }, [tableData]);

  const createPrestation = async () => {
    try {
      await plancomptaService.addCompte(newPrestation); // Utilisation de newPrestation pour ajouter la nouvelle prestation
      // Après l'ajout avec succès, rafraîchissez les données
      const updatedData = await plancomptaService.getAllPlanCompta();
      setTableData(updatedData);
      notification.success({
        message: "Ajout réussie",
        description: " compte ajouté avec succès.",
      });
      setShowCreateForm(false); // Masquer le formulaire après l'ajout
    } catch (error) {
      notification.error({
        message: "erreur",
        description: "Erreur lors de l'ajout  du compte",
      });
    }
  };
  /*  const fetchTypeCompteData = async (type_compte) => {
     setLoading(true);
     try {
       let data;
       if (type_compte === "") {
         data = await plancomptaService.getAllPlanCompta();
       } else {
         data = await plancomptaService.getTypeCompta(type_compte);
       }
       setTableData(data);
       setLoading(false);
     } catch (error) {
       console.error("Erreur lors de la récupération des données:", error);
       setLoading(false);
     }
   };
 
   useEffect(() => {
     fetchTypeCompteData(typeCompte); // Cela va charger tous les types au début
   }, []); // Les crochets vides signifient que cela ne s'exécutera qu'une fois après le premier rendu */

  const fetchTypeCompteData = async (type_compte) => {
    setLoading(true);
    try {
      const data = type_compte === ""
        ? await plancomptaService.getAllPlanCompta()
        : await plancomptaService.getTypeCompta(type_compte);
      setTableData(data);
      setFilteredData(data); // Also update filteredData on type selection
    } catch (error) {
      console.error("Erreur lors de la récupération des données du type de compte :", error);
    } finally {
      setLoading(false);
    }
  };

  // On type compte change, refetch data accordingly
  useEffect(() => {
    fetchTypeCompteData(typeCompte);
  }, [typeCompte]);

  // Ensuite, dans votre fonction handleSave, appelez la fonction createPrestation :
  const handleSave = () => {
    createPrestation();
    // Réinitialiser l'état ou effectuer d'autres actions si nécessaire
  };

  const handleDelete = async (compte) => {
    try {
      // Supposons que deletePrestation retourne maintenant un objet avec un champ deleted
      const response = await plancomptaService.deleteCompte(compte);

      if (response.Deleted) {
        const updatedData = await plancomptaService.getAllPlanCompta();
        setTableData(updatedData);
        setSelectedRowData(null); // Optionnel : réinitialiser la sélection
        notification.success({
          message: "Suppression réussie",
          description:
            "le compte  été supprimé avec succès.",
        });
      } else {
        // La suppression n'a pas eu lieu, afficher une notification d'échec
        notification.error({
          message: "Suppression impossible",
          description:
            "Le compte  ne peut pas être supprimée.",
        });
      }
    } catch (error) {
      // Gérer les erreurs avec une notification d'erreur
      notification.error({
        message: "Erreur",
        description:
          "Une erreur s'est produite lors de la suppression La ligne selectionnée du compte .",
      });
    }
  };

  const handleRowClick = async (record) => {
    try {
      // Affiche un indicateur de chargement, si tu en as un, pour indiquer que les données sont en cours de récupération
      setLoading(true);

      // Appelle l'API pour obtenir les détails du compte sur lequel l'utilisateur a cliqué
      const data = await plancomptaService.getOnePlanCompta(record.compte);

      // Si l'appel API réussit, utilise les données reçues pour mettre à jour l'état local
      setSelectedRowData(data);

      // Optionnel : masquer le formulaire de création si tu veux afficher les détails dans un formulaire de modification
      setShowCreateForm(false);
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des données du plan comptable:",
        error
      );
      // Affiche une notification d'erreur ou gère l'erreur comme tu le souhaites
    } finally {
      // Assure-toi de désactiver l'indicateur de chargement une fois que l'appel API est terminé, que ce soit un succès ou un échec
      setLoading(false);
    }
  };

  const handleNew = () => {
    setSelectedRowData(null); // Réinitialiser les données sélectionnées
    setShowCreateForm(true); // Afficher le formulaire de création lors du clic sur "Nouveau"

    // Mise à jour du formulaire pour le nouvel élément
    setNewPrestation({
      compte: "",
      intitule: "",

      type_compte: "Autres",

      solde: "0",
    });
    form.setFieldsValue({
      compte: "",
      intitule: "",

      type_compte: "Autres",

      solde: "0",
    });
  };

  /*  const handleSearch = (value) => {
     const filtered = tableData.filter((item) =>
       Object.values(item).some(
         (val) =>
           val && val.toString().toLowerCase().includes(value.toLowerCase())
       )
     );
 
     setFilteredData(filtered); // Met à jour les données filtrées
   }; */
  const handleSearch = (value) => {
    const filtered = tableData.filter((item) =>
      Object.values(item).some(
        (val) =>
          val && val.toString().toLowerCase().includes(value.toLowerCase())
      )
    );
    setFilteredData(filtered); // Update filtered data only
  };



  /*  const handleResetAll = async () => {
     try {
       setLoading(true);
       setTypeCompte(""); // Met à jour le type de compte à "Autres"
       const updatedData = await plancomptaService.getAllPlanCompta(); // Récupère les données pour "Autres"
       setTableData(updatedData); // Met à jour le tableau avec les nouvelles données
       setSelectedRowData(null); // Réinitialise les données sélectionnées
     } catch (error) {
       console.error("Erreur lors de la réinitialisation :", error);
     } finally {
       setLoading(false);
     }
   }; */
  const handleResetAll = async () => {
    setLoading(true);
    setTypeCompte(""); // Reset type compte
    await fetchAllPlanCompta(); // Refresh all data
  };

  const handleExport = () => {
    console.log("Type de compte pour l'exportation :", typeCompte);
    const exportData = tableData.map((item) => ({
      Niveau: item.cptegen,
      Sous_Compte: item.souscpte,
      Compte_Gen: item.compte,
      Intitule: item.intitule,
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Prestations");

    const fileName = `export_plan_compta_Comptes_${typeCompte || 'Tous'}.xlsx`;
    XLSX.writeFile(workbook, fileName);
  };

  function formatNumber(number) {
    const num = Number(number);
    if (isNaN(num)) {
      return "0";
    }

    return new Intl.NumberFormat("fr-FR").format(num);
  }

  /*  const columns = [
     {
       title: "Niveau",
       dataIndex: "cptegen",
       key: "cptegen",
       align: "center",
       ellipsis: true,
       render: (text) => <strong>{text}</strong>,
     },
     {
       title: "Sous Compte",
       dataIndex: "souscpte",
       key: "souscpte",
       ellipsis: true,
       align: "center",
     },
     {
       title: "Compte Gen.",
       dataIndex: "compte",
       key: "compte",
       //className: "small-cell",
       align: "center",
       ellipsis: true,
       // width: "10%",
     },
     {
       title: "Intitulé",
       dataIndex: "intitule",
       key: "intitule",
       ellipsis: true,
       //  width: "10%",
     },
     {
       title: (
         <div
           style={{
             backgroundColor: " #010f1c",
             color: "white",
             padding: "1px",
           }}
         ></div>
       ),
       key: "action",
       align: "center",
       ellipsis: true,
       render: (text, record) => (
         <Popconfirm
           title="Êtes-vous sûr de vouloir supprimer ce compte ?"
           onConfirm={() => handleDelete(record.compte)}
           okText="Oui"
           cancelText="Non"
         >
           <Button
             danger
             style={{ border: "none", fontSize: "16px" }}
             icon={<DeleteFilled />}
           ></Button>
         </Popconfirm>
       ),
     },
   ]; */
  const columns = [
    {
      title: "Niveau",
      dataIndex: "cptegen",
      key: "cptegen",
      align: "center",
      ellipsis: true,
      render: (text) => <strong>{text}</strong>,
      sorter: (a, b) => {
        if (!a.cptegen && b.cptegen) return 1;
        if (a.cptegen && !b.cptegen) return -1;
        if (!a.cptegen && !b.cptegen) return 0;
        return a.cptegen.localeCompare(b.cptegen);
      },
    },
    {
      title: "Sous Compte",
      dataIndex: "souscpte",
      key: "souscpte",
      ellipsis: true,
      align: "center",
      sorter: (a, b) => {
        if (!a.souscpte && b.souscpte) return 1;
        if (a.souscpte && !b.souscpte) return -1;
        if (!a.souscpte && !b.souscpte) return 0;
        return a.souscpte.localeCompare(b.souscpte);
      },
    },
    //  {
    //     title: "Compte Cipres",
    //     dataIndex: "cptecipres",
    //     key: "cptecipres",
    //     ellipsis: true,
    //     align: "center",
    //     sorter: (a, b) => {
    //       if (!a.cptecipres && b.cptecipres) return 1;
    //       if (a.cptecipres && !b.cptecipres) return -1;
    //       if (!a.cptecipres && !b.cptecipres) return 0;
    //       return a.cptecipres.localeCompare(b.cptecipres);
    //     },
    //   },
    {
      title: "Compte Gen.",
      dataIndex: "compte",
      key: "compte",
      align: "center",
      ellipsis: true,
      sorter: (a, b) => {
        if (!a.compte && b.compte) return 1;
        if (a.compte && !b.compte) return -1;
        if (!a.compte && !b.compte) return 0;
        return a.compte.localeCompare(b.compte);
      },
    },
    {
      title: "Intitulé",
      dataIndex: "intitule",
      key: "intitule",
      ellipsis: true,
      sorter: (a, b) => {
        if (!a.intitule && b.intitule) return 1;
        if (a.intitule && !b.intitule) return -1;
        if (!a.intitule && !b.intitule) return 0;
        return a.intitule.localeCompare(b.intitule);
      },
    },
    {
      title: (
        <div
          style={{
            backgroundColor: " #010f1c",
            color: "white",
            padding: "1px",
          }}
        ></div>
      ),
      key: "action",
      align: "center",
      ellipsis: true,
      render: (text, record) => (
        <Popconfirm
          title="Êtes-vous sûr de vouloir supprimer ce compte ?"
          onConfirm={() => handleDelete(record.compte)}
          okText="Oui"
          cancelText="Non"
        >
          <Button
            danger
            style={{ border: "none", fontSize: "16px" }}
            icon={<DeleteFilled />}
          ></Button>
        </Popconfirm>
      ),
    },
  ];

  const getButtonStyle = (value) => {
    return {
      backgroundColor: typeCompte === value ? '#010f1c' : '#f0f0f0', // vert foncé si sélectionné, sinon couleur par défaut
      color: typeCompte === value ? 'white' : 'black',
    };
  };

  return (
    <div style={{ padding: 12 }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          padding: "10px 20px",
          background: "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
          borderRadius: 10,
          boxShadow: "0 4px 15px rgba(24, 144, 255, 0.3)",
          marginBottom: 16,
        }}
      >
        <AccountBookOutlined style={{ fontSize: 22, color: "#fff" }} />
        <span
          style={{
            fontSize: 18,
            fontWeight: 600,
            color: "#fff",
            letterSpacing: 0.5,
            margin: 0,
          }}
        >
          Plan Comptable
        </span>
      </div>
      <Row gutter={[16, 16]}>
        <Col xs={24} xl={18}>
          <Card>
            <Row gutter={[16, 16]}>
              <Col
                span={12}
                style={{
                  textAlign: "right",
                  display: "flex",
                  justifyContent: "start",
                }}
              >
                <div style={{ display: "flex", flexWrap: "wrap", gap: 8, marginBottom: 16 }}>
                  {[
                    { value: "", label: "Tous" },
                    { value: "Autres", label: "Autres" },
                    { value: "Actifs", label: "Actifs" },
                    { value: "Charges", label: "Charges" },
                    { value: "Passifs", label: "Passifs" },
                    { value: "Produits", label: "Produits" },
                  ].map((item) => (
                    <button
                      key={item.value}
                      onClick={() => {
                        setTypeCompte(item.value);
                        fetchTypeCompteData(item.value);
                      }}
                      style={{
                        padding: "6px 14px",
                        borderRadius: 20,
                        border: "none",
                        cursor: "pointer",
                        fontSize: 13,
                        fontWeight: 500,
                        transition: "all 0.3s ease",
                        background: typeCompte === item.value
                          ? "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)"
                          : "#f0f0f0",
                        color: typeCompte === item.value ? "#fff" : "#595959",
                        boxShadow: typeCompte === item.value
                          ? "0 3px 10px rgba(24, 144, 255, 0.4)"
                          : "0 1px 3px rgba(0, 0, 0, 0.1)",
                      }}
                      onMouseEnter={(e) => {
                        if (typeCompte !== item.value) {
                          e.currentTarget.style.background = "#e0e0e0";
                          e.currentTarget.style.transform = "translateY(-1px)";
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (typeCompte !== item.value) {
                          e.currentTarget.style.background = "#f0f0f0";
                          e.currentTarget.style.transform = "translateY(0)";
                        }
                      }}
                    >
                      {item.label}
                    </button>
                  ))}
                </div>
              </Col>
              <Col
                span={12}
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <Space>
                  <Input
                    className="search-input-highlight"
                    placeholder="Rechercher..."
                    allowClear
                    prefix={<SearchOutlined style={{ color: "#8c8c8c" }} />}
                    style={{ width: 250 }}
                    onChange={(e) => handleSearch(e.target.value)}
                    onPressEnter={(e) => handleSearch(e.target.value)}
                  />

                  <Button
                    className="buttonExport"
                    icon={<ExportOutlined />}
                    onClick={handleExport}
                  >
                    Export
                  </Button>
                  <Button className="buttonRefresh" onClick={handleResetAll} icon={<SyncOutlined />}>
                    Actualiser
                  </Button>
                </Space>
              </Col>
            </Row>
          </Card>

          <Table
            scroll={{ x: true }}
            className="custom-header1-table"
            style={{ cursor: "pointer", whiteSpace: "nowrap", width: "100%" }}
            bordered
            columns={columns}

            showSorterTooltip={false}
            dataSource={filteredData}
            onRow={(record) => ({
              onClick: () => handleRowClick(record),
            })}
            loading={loading}
          />
        </Col>

        <Col xs={24} xl={6}>
          {showCreateForm ? (
            <Card
              size="small"
              className="custom-card"
              style={{
                borderRadius: 12,
                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
                border: "none",
                overflow: "hidden",
              }}
              title={
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  padding: "4px 0",
                }}>
                  <PlusCircleOutlined style={{ fontSize: 20, color: "#fff" }} />
                  <Title
                    level={5}
                    style={{ margin: 0, color: "#ffffff", fontWeight: 600 }}
                  >
                    Nouveau Compte
                  </Title>
                </div>
              }
            >
              <Form form={form} layout="vertical" onFinish={handleSave} style={{ marginTop: 8 }}>
                <Form.Item
                  label={<span style={{ fontWeight: 500, color: "#333" }}>Compte Général (min. 6 car.)</span>}
                  name="compte"
                  rules={[
                    { required: true, message: "Champs requis." },
                    { min: 6, message: "Le compte doit contenir au moins 6 caractères." },
                  ]}
                  style={{ marginBottom: 16 }}
                >
                  <Input
                    placeholder="Ex: 411000"
                    value={newPrestation.compte}
                    onChange={(e) =>
                      setNewPrestation({ ...newPrestation, compte: e.target.value })
                    }
                    style={{ borderRadius: 6 }}
                  />
                </Form.Item>
                {/* <Form.Item
                  name="cptecipres"
                  label={<span style={{ fontWeight: 500, color: "#333" }}>Compte Cipres Associé</span>}
                  style={{ marginBottom: 16 }}
                >
                  <Input
                    placeholder="Compte Cipres"
                    value={newPrestation.cptecipres}
                    onChange={(e) =>
                      setNewPrestation({ ...newPrestation, cptecipres: e.target.value })
                    }
                    style={{ borderRadius: 6 }}
                  />
                </Form.Item> */}
                <Form.Item
                  name="intitule"
                  label={<span style={{ fontWeight: 500, color: "#333" }}>Intitulé de compte</span>}
                  rules={[{ required: true, message: "Champs requis" }]}
                  style={{ marginBottom: 16 }}
                >
                  <Input
                    placeholder="Intitulé du compte"
                    value={newPrestation.intitule}
                    onChange={(e) =>
                      setNewPrestation({ ...newPrestation, intitule: e.target.value })
                    }
                    style={{ borderRadius: 6 }}
                  />
                </Form.Item>
                <Form.Item
                  label={<span style={{ fontWeight: 500, color: "#333" }}>Solde du Compte</span>}
                  style={{ marginBottom: 16 }}
                >
                  <Input
                    disabled
                    value={newPrestation.solde}
                    style={{ borderRadius: 6, backgroundColor: "#f5f5f5" }}
                  />
                </Form.Item>
                <Form.Item
                  label={<span style={{ fontWeight: 500, color: "#333" }}>Type de Compte</span>}
                  style={{ marginBottom: 20 }}
                >
                  <Select
                    defaultValue="Autres"
                    style={{ width: "100%", borderRadius: 6 }}
                    onChange={(value) =>
                      setNewPrestation({ ...newPrestation, type_compte: value })
                    }
                    value={newPrestation.type_compte}
                  >
                    <Option value="Autres">Autres</Option>
                    <Option value="Actifs">Actifs</Option>
                    <Option value="Charges">Charges</Option>
                    <Option value="Passifs">Passifs</Option>
                    <Option value="Produits">Produits</Option>
                    <Option value="Tous">Tous</Option>
                  </Select>
                </Form.Item>

                <Form.Item style={{ marginBottom: 0, paddingTop: 8, borderTop: "1px solid #f0f0f0" }}>
                  <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
                    <Button
                      icon={<CloseOutlined />}
                      onClick={() => setShowCreateForm(false)}
                      style={{
                        borderRadius: 6,
                        border: "1px solid #d9d9d9",
                        fontWeight: 500,
                      }}
                    >
                      Annuler
                    </Button>
                    <Button
                      type="primary"
                      htmlType="submit"
                      icon={<SaveOutlined />}
                      style={{
                        background: "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
                        border: "none",
                        borderRadius: 6,
                        fontWeight: 500,
                        boxShadow: "0 2px 8px rgba(24, 144, 255, 0.35)",
                      }}
                    >
                      Enregistrer
                    </Button>
                  </div>
                </Form.Item>
              </Form>
            </Card>
          ) : (
            <Card
              size="small"
              className="custom-card"
              style={{
                borderRadius: 12,
                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
                border: "none",
                overflow: "hidden",
              }}
              title={
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  padding: "4px 0",
                }}>
                  <EditOutlined style={{ fontSize: 20, color: "#fff" }} />
                  <Title
                    level={5}
                    style={{ margin: 0, color: "#ffffff", fontWeight: 600 }}
                  >
                    Modification Compte
                  </Title>
                </div>
              }
            >
              <Form layout="vertical" style={{ marginTop: 8 }}>
                <Form.Item
                  label={<span style={{ fontWeight: 500, color: "#333" }}>Compte Général</span>}
                  style={{ marginBottom: 16 }}
                >
                  <Input
                    disabled
                    value={selectedRowData ? selectedRowData.compte : ""}
                    style={{ borderRadius: 6, backgroundColor: "#f5f5f5" }}
                  />
                </Form.Item>
                <Form.Item
                  label={<span style={{ fontWeight: 500, color: "#333" }}>Compte Cipres Associé</span>}
                  style={{ marginBottom: 16 }}
                >
                  <Input
                    placeholder="Compte Cipres"
                    value={selectedRowData ? selectedRowData.cptecipres : ""}
                    onChange={(e) =>
                      setSelectedRowData({ ...selectedRowData, cptecipres: e.target.value })
                    }
                    style={{ borderRadius: 6 }}
                  />
                </Form.Item>
                <Form.Item
                  label={<span style={{ fontWeight: 500, color: "#333" }}>Intitulé de Compte</span>}
                  style={{ marginBottom: 16 }}
                >
                  <Input
                    placeholder="Intitulé du compte"
                    value={selectedRowData ? selectedRowData.intitule : ""}
                    onChange={(e) =>
                      setSelectedRowData({ ...selectedRowData, intitule: e.target.value })
                    }
                    style={{ borderRadius: 6 }}
                  />
                </Form.Item>
                <Form.Item
                  label={
                    <span style={{ fontWeight: 500, color: "#333" }}>
                      Solde du Compte ({formatNumber(selectedRowData ? selectedRowData.solde : "")})
                    </span>
                  }
                  style={{ marginBottom: 16 }}
                >
                  <Input
                    disabled
                    min={0}
                    value={formatNumber(selectedRowData ? selectedRowData.solde : "")}
                    style={{ borderRadius: 6, backgroundColor: "#f5f5f5" }}
                  />
                </Form.Item>
                <Form.Item
                  label={<span style={{ fontWeight: 500, color: "#333" }}>Type de Compte</span>}
                  style={{ marginBottom: 20 }}
                >
                  <Select
                    style={{ width: "100%", borderRadius: 6 }}
                    onChange={(value) =>
                      setSelectedRowData({ ...selectedRowData, type_compte: value })
                    }
                    value={selectedRowData ? selectedRowData.type_compte : ""}
                  >
                    <Option value="">Sélectionner</Option>
                    <Option value="Autres">Autres</Option>
                    <Option value="Actifs">Actifs</Option>
                    <Option value="Charges">Charges</Option>
                    <Option value="Passifs">Passifs</Option>
                    <Option value="Produits">Produits</Option>
                    <Option value="Tous">Tous</Option>
                  </Select>
                </Form.Item>
                <Form.Item style={{ marginBottom: 0, paddingTop: 8, borderTop: "1px solid #f0f0f0" }}>
                  <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
                    <Button
                      icon={<PlusCircleOutlined />}
                      onClick={handleNew}
                      style={{
                        borderRadius: 6,
                        border: "1px solid #1890ff",
                        color: "#1890ff",
                        fontWeight: 500,
                      }}
                    >
                      Nouveau
                    </Button>
                    <Button
                      icon={<SaveOutlined />}
                      onClick={handleUpdate}
                      style={{
                        background: "linear-gradient(135deg, #11998e 0%, #38ef7d 100%)",
                        border: "none",
                        color: "#fff",
                        borderRadius: 6,
                        fontWeight: 500,
                        boxShadow: "0 2px 8px rgba(56, 239, 125, 0.35)",
                      }}
                    >
                      Modifier
                    </Button>
                  </div>
                </Form.Item>
              </Form>
            </Card>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PlanCompta;
